import { render, staticRenderFns } from "./comp-language.vue?vue&type=template&id=5108f62b&scoped=true&lang=pug&"
import script from "./comp-language.vue?vue&type=script&lang=js&"
export * from "./comp-language.vue?vue&type=script&lang=js&"
import style0 from "./comp-language.vue?vue&type=style&index=0&id=5108f62b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108f62b",
  null
  
)

export default component.exports